export default __webpack_public_path__ + "static/media/app-bar-logo.7ea61fde.svg";